import { Injectable } from '@angular/core';
import { Observable, forkJoin, Subject } from 'rxjs';

declare const document: any;

@Injectable()
export class ScriptLoaderService {
  private scripts: { [url: string]: boolean } = {};

  constructor() {}

  load(...scripts: string[]): Observable<any> {
    return forkJoin(scripts.map((s) => this.loadScript(s)));
  }

  loadScript(url: string): Observable<any> {
    const res = new Subject();
    // resolve if already loaded
    if (this.scripts[url]) {
      res.next({ script: url, loaded: true });
      res.complete();
    } else {
      // load script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            this.scripts[url] = true;
            res.next({ script: url, loaded: true });
            res.complete();
          }
        };
      } else {
        // Others
        script.onload = () => {
          this.scripts[url] = true;
          res.next({ script: url, loaded: true, status: 'Loaded' });
          res.complete();
        };
      }
      script.onerror = (error: any) => res.error({ script: url, loaded: false });
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    return res;
  }
}
